<app-card [cardClasses]="cardClass" cardHeaderTitle="{{ title }}" [titleInBody]="titleInBody" [header]="!titleInBody" [cardBodyClasses]="titleInBody ? '' : 'pt-0'">
  <ng-container cardBody>
    <app-skeleton-text [count]="6" [type]="'text-and-image'" [isLoading]="loading">
      <div class="row mb-7">
        <div class="col-sm-6 mb-10" *ngFor="let item of bodyList">
          <div class="card-document">
            <label class="text-gray-400 mb-8">{{ item.label }}</label>
            <div class="img-document d-flex justify-content-center align-items-center min-h-250px">
              <ng-container *ngIf="item.value; else noValue">
                <app-image-preview [image]="item.value" [openTextLabel]="false" [height]="200" [titleModal]="item.label"></app-image-preview>
              </ng-container>
            </div>
            <ng-template #noValue>
              <h3 class="text-gray-400">Dokumen Tidak Tersedia</h3>
            </ng-template>
          </div>
        </div>
      </div>
    </app-skeleton-text>
  </ng-container>
</app-card>
